<div class="modal" data-iframe-size>
  <img class="icon" src="assets/img/msg-warning.svg">
  <h4 class="title">
    {{ 'i18n.dialog.error.title' | translate:errors.length }}
  </h4>

  <mat-dialog-content *ngFor="let key of Object.keys(errors)">
    <div class="content">
      <div>
        <strong>{{ key }}</strong>
        <p *ngFor="let error of errors[key]; trackBy: trackByTitle ">
          {{ error.text }}
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/error-dialog/error-dialog.component.html